import { Box, Card, CardContent, Divider, Skeleton } from "@mui/material";
import React from "react";

const ApplicationsSkeleton: React.FC = () => {
	return (
		<Box>
			<Card
				sx={{
					borderBottomLeftRadius: 0,
					borderBottomRightRadius: 0,
					borderTopRightRadius: 15,
					borderTopLeftRadius: 15,
					border: `1px solid rgba(0, 0, 0, 0.12)`,
					backgroundColor: "transparent",
					boxShadow: "none"
				}}
			>
				{Array.from({ length: 5 }, (_, index) => (
					<React.Fragment key={`skeleton-item-${index}`}>
						<CardContent
							sx={{
								pt: index === 0 ? "32px" : "auto"
							}}
						>
							<Box display="flex" alignItems="flex-start" gap={3}>
								{/* Avatar Skeleton */}
								<Skeleton variant="circular" width={50} height={50} />

								{/* Main content Skeleton */}
								<Box flex={1}>
									{/* Name and expertise line */}
									<Box display="flex" flexDirection="row" alignItems="flex-start" gap={1}>
										<Skeleton variant="text" width="35%" height={32} />
										<Skeleton variant="text" width="2%" height={32} />
										<Skeleton variant="text" width="25%" height={32} />
									</Box>

									{/* Dates */}
									<Box mt={"1px"}>
										<Skeleton variant="text" width="40%" height={20} />
										<Skeleton variant="text" width="35%" height={20} />
										<Skeleton variant="text" width="38%" height={20} />
									</Box>
								</Box>

								{/* Right side Skeleton */}
								<Box
									display="flex"
									flexDirection="column"
									alignItems="flex-end"
									gap={4}
									position="relative"
									bottom={0}
								>
									{/* Icons */}
									<Box display="flex" gap={0.7}>
										<Skeleton variant="circular" width={24} height={24} />
										<Skeleton variant="circular" width={24} height={24} />
									</Box>

									{/* Status dropdown */}
									<Skeleton variant="rectangular" width={200} height={40} />
								</Box>
							</Box>
						</CardContent>
						{index < 3 && (
							<Divider sx={{ height: 16 }} orientation="horizontal" variant="middle" />
						)}
					</React.Fragment>
				))}
			</Card>
		</Box>
	);
};

export default ApplicationsSkeleton;
